export default __webpack_public_path__ + "5bd93ac737d3161965797e6618586ea6.svg";